import { getMethods as getLoginMethods } from './Login';
import { getMethods as getUserStartupMethods } from './UserStartup';
import { getMethods as getWebInterfaceManagementMethods } from './WebInterfaceManagement';
import { getMethods as getUiTourMethods } from './UiTour';

const getController = (service: 'login') => ({
	Login: getLoginMethods(service, 'Login'),
	UserStartup: getUserStartupMethods(service, 'UserStartup'),
	WebInterfaceManagement: getWebInterfaceManagementMethods(service, 'WebInterfaceManagement'),
	UiTour: getUiTourMethods(service, 'UiTour')
});

export { getController };
